export const routes = {
  DEFAULT: "/automation",
  CREATE: "/automation/create",
  DETAIL: "/automation/details",
};

export const Trigger = "trigger";
export const inactivateModalText = `All actions and conditions within the workflow will be halted for the enrolled contacts until you reactivate it.`;
export const cloneModalText = `Are you sure you want to clone this workflow?`;
export const cloningWorkflowModalText = `Cloning this workflow`;
export const clonedWorkflowModalText = `Workflow Cloned`;
export const cloningWorkflowPermissionError = `Cannot clone: Obtain permissions for all emails in the workflow before cloning`;
export const saveWorkflowSuccess = `Your workflow has been saved successfully!`;
export const publishWorkflowSuccess = `Your workflow has been published successfully!`;

export const CONTROLS_NAMES = {
  "send email": "Email",
  "add to list": "Add to list",
  delay: "Delay",
  end: "Stop",
  "If / Else": "Condition",
};

export const EVENT_IDS = {
  EMAIL_OPEN: 7,
  EMAIL_CLICK: 8,
  EMAIL_RECEIVED: 9,
  SHARE_PROFILE: 10,
  EMAIL_SEQUENCE: 11,
};
